import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useTheme } from "@/comn/hooks";
import React, { useEffect } from "react";
import {
    APIS,
    SF_CSTM_OFCR_INFO,
    SG_CSTM_USR_AUTH_LIST,
    URLS,
} from "@/tra/tancis/ptli/ptl/cstmauth/service/PtliCstmAuthService";
import { useNavigate, useParams } from "react-router-dom";
import { PTLI1007003Q } from "@/tra/tancis/ptli/ptl/cstmauth/PTLI1007003Q";
import { comnUtils } from "@/comn/utils";

/*
 * Save. Custom Office User Auth Data
 * !== 세관 사용자 권한 저장. ==!
 */
export const PTLI1007002S = (): JSX.Element => {
    const modal = useModal();
    const param = useParams();
    const navigate = useNavigate();
    const { theme } = useTheme();
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });

    const form = {
        cstmOfcrInfo: useForm({ defaultSchema: SF_CSTM_OFCR_INFO }),
    };

    const fetch = {
        getCstmUsrAuthList: useFetch({
            api: (data) => APIS.getCstmUsrAuthList(data),
            onSuccess: (data: any) => {
                const { content } = data.usrInfo;

                form.cstmOfcrInfo.setValues(content);
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        saveCstmUsrAuthList: useFetch({
            api: () =>
                APIS.saveCstmUsrAuthList({
                    usrDmnId: param["usrDmnId"],
                    cstmUsrAuthList: grid.cstmUsrAuthList.getData(),
                }),
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00062" }); // 정상적으로 저장되었습니다.
                fetch.getCstmUsrAuthList.fetch({ usrDmnId: param["usrDmnId"] });
            },
            onError: () => modal.openModal({ content: "msg.com.00026" }), // Failed to save. !==  저장이 실패하였습니다. ==!
        }),
    };

    const grid = {
        cstmUsrAuthList: useGrid({ defaultSchema: SG_CSTM_USR_AUTH_LIST }),
    };

    const handler = {
        onBtnSaveClick: () => {
            const list = grid.cstmUsrAuthList.getData({ excludes: ["origin"] });
            if (list.length === 0) {
                modal.openModal({ content: "msg.ptl.00741" }); // There is no data to be stored and deleted. !== 저장 및 삭제 대상 데이터가 없습니다. ==!
                return;
            }

            modal.openModal({
                content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                onConfirm: () => fetch.saveCstmUsrAuthList.fetch(),
            });
        },

        onBtnGrdAddRowClick: () => {
            const data = grid.cstmUsrAuthList.getData({ excludes: ["origin"] }); // INSERT, DELETE

            if (!comnUtils.isEmpty(data)) {
                modal.openModal({ content: "msg.ptl.00745" }); // Data has been changed. Please save it and proceed. !== 데이터가 변경되었습니다. 저장 후 진행해 주세요. ==!
                return;
            }

            const modalCallback = (list: any) => {
                const authList = grid.cstmUsrAuthList.getData();
                list.forEach(
                    (item: any) =>
                        authList.findIndex((subItem: any) => item.authId === subItem.authId) === -1 &&
                        grid.cstmUsrAuthList.addRow(item),
                );
                modal.closeModal();
            };

            modal.openModal({
                draggable: true,
                size: "md",
                content: (
                    <PTLI1007003Q
                        usrDmnId={param["usrDmnId"]}
                        cstmUsrAuthList={grid.cstmUsrAuthList.getData()}
                        callback={modalCallback}
                    />
                ),
            });
        },

        onBtnGrdDelRowClick: () => {
            if (comnUtils.isEmpty(grid.cstmUsrAuthList.getChecked())) {
                modal.openModal({ content: "msg.com.00086" }); // No data has been selected.. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            modal.openModal({
                content: "msg.com.00049",
                onConfirm: () => {
                    grid.cstmUsrAuthList.deleteRow("checkbox");
                },
            });
        },
    };

    const render = {
        checkbox: (data: any) => {
            return data.roleTyCd !== "R";
        },
        cell: {
            authUndrRole: (props: any) => {
                const { rowValues, value } = props;

                if (rowValues.roleTyCd == "R") {
                    return "Y";
                } else {
                    return "N";
                }
            },
        },
    };

    useEffect(() => {
        fetch.getCstmUsrAuthList.fetch({ usrDmnId: param["usrDmnId"] });
    }, [theme]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrInfo.schema.sctnNm} />
                            <Group.Control {...form.cstmOfcrInfo.schema.cstmNm} />
                            <Group.Control {...form.cstmOfcrInfo.schema.unitNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrInfo.schema.usrDmnId} />
                            <Group.Control {...form.cstmOfcrInfo.schema.cstmOfcrNo} />
                            <Group.Control {...form.cstmOfcrInfo.schema.usrNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrInfo.schema.usrTelno} controlSize={2} />
                            <Group.Control {...form.cstmOfcrInfo.schema.usrEmlAddr} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section gap={2}>
                        <Layout.Right>
                            <Button role={"gridAdd"} onClick={handler.onBtnGrdAddRowClick} />
                            <Button role={"gridDelete"} onClick={handler.onBtnGrdDelRowClick} />
                        </Layout.Right>

                        <Grid
                            {...grid.cstmUsrAuthList.grid}
                            data={fetch.getCstmUsrAuthList.data?.cstmUsrAuthList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Button role={"list"} onClick={() => navigate(`${URLS.ptli1007001q}`)} />
                </Layout.Left>
                <Layout.Right>
                    <Button role={"save"} onClick={handler.onBtnSaveClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
